import {ConfirmOrderController, useConfirmOrderContext} from "../../../../../../reducer/moduleReducer/confirmOrder";
import {useTranslation} from "react-i18next";
import {useEffect, useMemo} from "react";
import Modal from "../../../../../../publicComponent/Modal";
import CouponCard from "../../../../components/CouponCard";
import Button from "../../../../../../publicComponent/Button";
import {isEmptyObj} from "../../../../../../utils";
import SubmitOrderButton from "../../../../../../publicComponent/submitOrderButton";

function BillRow({ children, label, value, className, onClick, coupon }) {
  const { removeCoupon } = ConfirmOrderController();
  
  return (
    <div className="flex mdmax:container">
      {
        children
          ? children
          : <>
            <p className="py-[12px] text-left mdmax:flex-1 text-[#999]">{label}</p>
            <p onClickCapture={onClick} className={`py-[12px] mdmax:flex-1 pl-[10px] ${className}`}>
              {value}
            </p>
            {coupon && !isEmptyObj(coupon) ?
              <i onClickCapture={removeCoupon}
                 className="pt-[8px] iconfont icon-close-circle-fill ml-[10px] text-[#fe4646] text-[18px] cursor-pointer"></i>
              : null}
          </>
      }
    </div>
  );
}

export default function BillCard({ isEdit }) {
  const { getCouponList, couponListVisibleHandle, selectCoupon } = ConfirmOrderController();
  const { state } = useConfirmOrderContext();
  const { expressFee, billData, coupon, couponList, couponListModalVisible,expressType } = state;
  const { t } = useTranslation();
  
  useEffect(() => {
    getCouponList();
  }, []);
  
  let couponAmount = useMemo(() => {
    
    if (!isEmptyObj(coupon)) {
      return `${t('优惠券')}: ${t('满')} ${coupon.thresholdAmount} ${coupon.couponType != 2 ? t('减') + coupon.thresholdValue : ' | ' + coupon.thresholdValue + t('折')}`;
    }
    
    if (couponList.length > 0) {
      return `+ ${t('使用优惠券')}`;
    }
    
    return t('无') + t('可用优惠券');
  }, [coupon, couponList]);
  
  // {{ $t('优惠券') }}： {{ $t('满') }}{{
  //   couponItem.thresholdAmount
  // }}{{ couponItem.couponType != 2 ? $t('减') + couponItem.thresholdValue : couponItem.thresholdValue + $t('折') }}
  
  return (
    <>
      <div className="md:py-[25px] md:border-t border-[#d4d4d4] md:bg-[#fbfbfb] md:pr-[32px]">
        <div className="px-[15px] flex mdmax:flex-col">
          <div className="w-[240px] h-[100px] mr-[3%] mdmax:hidden flex-none pl-[40px]">
            <BillRow onClick={() => couponListVisibleHandle(true)}
                     coupon={coupon}
                     value={couponAmount}
                     className="cursor-pointer"/>
          </div>
          <div className="flex-1 flex flex-col items-end text-right
                      mdmax:divide-y divide-[#eee]">
            <div className="md:hidden w-[100%]">
              <BillRow onClick={() => couponListVisibleHandle(true)}
                       coupon={coupon}
                       value={couponAmount}
                       className="cursor-pointer"/>
            </div>
            <BillRow label={t('商品总计')} value={`$${billData.goodsTotolPrice}`}/>
            <BillRow label={t('优惠金额')} value={`$${billData.discountAmount || 0}`}/>
            {
              expressType === 2 && (
                <BillRow label={t('运费')} value={`$${expressFee}`}/>   
              )
            }
            {/*<BillRow>*/}
            {/*  <p className="py-[15px] text-[#999]">{t('应付金额')}</p>*/}
            {/*  <p className="py-[15px] md:hidden mdmax:flex-1 text-[16px] font-bold">${billData.totalPrice}</p>*/}
            {/*</BillRow>*/}
          </div>
        </div>
        <div className="text-right mdmax:hidden flex items-center justify-end">
          <BillRow>
            <p className="py-[15px] text-[#999]">{t('应付金额')}</p>
            <p className="py-[15px] mdmax:flex-1 px-[40px] text-[16px] mdmax:text-[#F43E38] font-bold">${billData.totalPrice}</p>
          </BillRow>
          <SubmitOrderButton/>
        </div>
      </div>
      <Modal visible={couponListModalVisible}
             width={900}
             mt={'1vh'}
             onClose={couponListVisibleHandle}
             footer={null}
             title="选择优惠券">
        <div className="grid grid-cols-2 mdmax:grid-cols-1 mdmax:p-[12px] gap-4"
             style={{ maxHeight: '63vh', overflowY: 'scroll' }}>
          {
            couponList.map((item, i) => (
              <CouponCard data={item}
                          button={
                            <Button onClick={() => selectCoupon(item)}>
                              {t('立即使用')}
                            </Button>
                          }
                          key={i}/>
            ))
          }
        </div>
      </Modal>
    </>
  );
}
